/**
 * x-add-to-cart directive.
 *
 * Manages the enabled/disabled state of an add-to-cart button. Listens for
 * `disable` and `enable` custom events dispatched by sibling components (such
 * as the variant picker) to reflect unavailable or loading states.
 *
 * Expects a `$refs.button` pointing to the underlying `<button>` element.
 *
 * @example
 *   <div x-add-to-cart>
 *     <button x-ref="button" type="submit">Add to cart</button>
 *   </div>
 */
(() => {
  const root = (Alpine, el) => {
    Alpine.bind(el, () => {
      return {
        ["x-data"]() {
          return {
            /**
             * Disables the add to cart button.
             */
            disable() {
              this.$refs.button.disabled = true;
            },

            /**
             * Enables the add to cart button.
             */
            enable() {
              this.$refs.button.disabled = false;
            },

            /**
             * Returns whether the add to cart button is currently disabled.
             * @returns {boolean} True when the button is disabled.
             */
            get disabled() {
              return this.$refs?.button.disabled;
            },
          };
        },

        ["@disable"]() {
          this.disable();
        },

        ["@enable"]() {
          this.enable();
        },
      };
    });
  };

  document.addEventListener("alpine:init", () => {
    Alpine.directive("add-to-cart", (el, { expression }, { evaluate }) => {
      const options = expression ? evaluate(expression) : {};

      root(Alpine, el, options);
    }).before("bind");
  });
})();
